"use client";

import { useSyncExternalStore } from "react";

import { NO_COMMIT_HOSTS, SITE_COMMIT, SITE_VERSION } from "../../lib/version";

const noSubscribe = () => () => {};

// «نسخه v1.0.0 · 240faa6c1d» (F173): the commit on dev and staging hosts, never
// on shemshop.ir. The server render has no commit, so it never flashes there.
export function SiteVersion({ className }: { className?: string }) {
  const withCommit = useSyncExternalStore(noSubscribe, () => !NO_COMMIT_HOSTS.includes(window.location.hostname), () => false);
  return (
    <p className={className}>
      نسخه <span dir="ltr">{withCommit ? `v${SITE_VERSION} · ${SITE_COMMIT}` : `v${SITE_VERSION}`}</span>
    </p>
  );
}
